<template>
  <footer class="footer">
    <div class="footer__toggle">
      <button @click="toggleFooterDesc = !toggleFooterDesc">
        <v-icon v-if="!toggleFooterDesc">mdi-chevron-up</v-icon>
        <v-icon v-if="!!toggleFooterDesc">mdi-chevron-down</v-icon>
      </button>
    </div>
    <div class="footer__desc"
         :class="{'footer__desc--show' : !!toggleFooterDesc}">
      <div class="footer__logo">
        <div>
          <img
            alt="loga projeku: fundusze europejskie, małopolska, unia europejska"
            src="@/assets/img/footer/program-regionalny-logo.png">
          <img
            alt="loga projeku: fundusze europejskie, małopolska, unia europejska"
            src="@/assets/img/footer/rp-logo.png">
          <img
            alt="loga projeku: fundusze europejskie, małopolska, unia europejska"
            src="@/assets/img/footer/malopolska-logo.png">
          <img
            alt="loga projeku: fundusze europejskie, małopolska, unia europejska"
            src="@/assets/img/footer/ue-logo.png">
        </div>
      </div>
      <div class="footer__disclaimer">
        Projekt nr RPMP.04.05.02-12-0387/17
        „Integracja transportu publicznego w Tarnowie”
        współfinansowany przez Unię Europejską w ramach
        Regionalnego Programu Operacyjnego Województwa Małopolskiego
        na lata 2014-2020
      </div>
    </div>
  </footer>
</template>

<script>
/*eslint-disable */
/* tslint:disable */
import { ref } from '@vue/composition-api';

export default {
  name: 'FooterContent',
  components: {},
  setup() {
    const toggleFooterDesc = ref(false);

    return {
      toggleFooterDesc,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~sass-rem/rem';
@import '~vuetify/src/styles/styles.sass';

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: #285397 solid rem(2px);
  background-color: #FFFFFF;
  width: 100vw;
  //position: relative;
  position: fixed;
  bottom: 0;
  z-index: 1;

  @media #{map_get($display-breakpoints, 'sm-and-down')} {
    height: auto;
  }

  &__desc {
    flex: 1;
    transition: all 0.3s ease-in-out;

    @media #{map_get($display-breakpoints, 'sm-and-down')} {
      height: 0;
      max-height: 0;
      overflow: hidden;
      opacity: 0;
    }

    &--show {
      transition: all 0.3s ease-in-out;
      height: auto;
      max-height: 100%;
      overflow: auto;
      opacity: 1;
    }
  }

  &__toggle {
    position: absolute;
    background-color: #fff;
    top: -27px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    border: #285397 solid rem(2px);
    border-bottom: none;

    @media #{map_get($display-breakpoints, 'md-and-up')} {
      display: none;
    }
  }

  &__logo {
    > div {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      @media #{map_get($display-breakpoints, 'sm-and-down')} {
        max-width: 80%;
        margin: 0 auto;
      }

      img {
        max-height: 70px;
        width: auto;

        @media #{map_get($display-breakpoints, 'sm-and-down')} {
          width: auto;
          max-height: 50px;
        }
      }
    }
  }

  &__disclaimer {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: rem(0.44px);
    color: #000000;
    text-align: center;
    padding: 5px 15px;
    @media #{map_get($display-breakpoints, 'md-and-down')} {
      font-size: 7px;
    }
  }
}
</style>
